import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { SideNavigationItem } from 'shared/components/ui/side-navigation-item';
import { version } from 'shared/constants';

import { settingsNavGroups, SettingsSection } from './settings-nav';
import * as Styled from './settings-navigation.style';

export type SettingsNavigationProps = {
  activeSection: SettingsSection;
  onSelect: (section: SettingsSection) => void;
};

export const SettingsNavigation: React.FC<SettingsNavigationProps> = ({
  activeSection,
  onSelect,
}) => {
  const { t } = useTranslation();

  return (
    <Styled.Sidebar>
      <Styled.TitleContainer>
        <Typography variant="h5" component="h1">
          {t('forms.user-settings.title')}
        </Typography>
      </Styled.TitleContainer>

      <Styled.Nav>
        {settingsNavGroups.map((group, index) => (
          <Styled.Group key={group.translationLabel ?? `group-${index}`}>
            {!!group.translationLabel && (
              <Styled.GroupHeader>
                {t(group.translationLabel)}
              </Styled.GroupHeader>
            )}

            {group.items.map((item) => (
              <SideNavigationItem
                key={item.section}
                label={t(item.translationLabel)}
                icon={item.icon}
                active={item.section === activeSection}
                onClick={() => onSelect(item.section)}
              />
            ))}
          </Styled.Group>
        ))}
      </Styled.Nav>

      <Styled.Footer>
        <Styled.Version variant="overline">{version}</Styled.Version>
      </Styled.Footer>
    </Styled.Sidebar>
  );
};
